import { AxiosInstance } from "axios"
import { Message, MessageAdditionalData, MessageDetails, MessageItem } from "./messagesTypes"
import { ServiceResponse } from "../../../../core/api/apiTypes"

export enum MerchantMessagesQuery {
    LIST = "messages-for-merchant",
    DETAILS = "message-details-for-merchant",
}

type FetchMessagesParams = Readonly<{
    merchantId: number
    startDate: string
    endDate: string
}>

export type FetchMessagesResponse = Readonly<{
    messages: Message[]
}>

export async function fetchMessages(
    { merchantId, startDate, endDate }: FetchMessagesParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchMessagesResponse> {
    const url = `/merchants/${merchantId}/messages`

    const { data } = await axios.get(url, {
        params: {
            startDate,
            endDate,
        },
        signal,
    })

    return data
}

type DeleteMessageItemParam = Readonly<{
    messageId: number
}>

export async function deleteMessageItem(
    { messageId }: DeleteMessageItemParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { data } = await axios.delete(`/messages/${messageId}`, {
        signal,
    })
    return data
}

type MessageParam = Readonly<{
    messageId: string
}>

export type FetchMessageResponse = Readonly<{
    message: MessageDetails
}>

export async function fetchMessage(
    { messageId }: MessageParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchMessageResponse> {
    const url = `/messages/${messageId}`

    const { data } = await axios.get(url, {
        signal,
    })
    return data
}

export async function createMessage(
    { message, messageAdditionalData }: { message: MessageItem; messageAdditionalData: MessageAdditionalData },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { data } = await axios.post(
        `/messages`,
        {
            message: { ...message, ...messageAdditionalData },
        },
        {
            signal,
        },
    )
    return data
}
export async function updateMessage(
    { message, messageId }: { message: MessageItem; messageId: string },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { data } = await axios.post(
        `/messages/${messageId}`,
        {
            message,
        },
        {
            signal,
        },
    )
    return data
}
